import { GetCollectionFieldsResultData } from '@indigohive/cogfy-types/endpoints/getCollectionFields'
import { GetRecordByIdResult } from '@indigohive/cogfy-types/endpoints/getRecordById'
import { OptionChip, OptionChipColorName } from '../../../../components'
import clsx from 'clsx'
import { useState } from 'react'
import { HttpResponseRecordProperty } from '@indigohive/cogfy-types'

export type HttpResponseRecordPropertyInputProps = {
  field: Extract<GetCollectionFieldsResultData, { type: 'httpResponse' }>
  record: GetRecordByIdResult
  disabled?: boolean
  error?: boolean
}

const getStatusColor = (status: string): OptionChipColorName => {
  if (status.startsWith('2')) {
    return 'green'
  } else if (status.startsWith('4')) {
    return 'red'
  }
  return 'red'
}

export function HttpResponsePropertyInput (props: HttpResponseRecordPropertyInputProps) {
  const { field, record, error, disabled } = props
  const [textWrap, setTextWrap] = useState(false)

  const properties = record.properties[field.id] as HttpResponseRecordProperty | undefined
  const value = properties?.httpResponse?.value
  const body = value?.body
  const status = value?.status ?? ''
  const duration = value?.duration?.toFixed(0) ?? 0

  const statusColor = value?.status ? getStatusColor(value.status.toString()) : 'red'

  return (
    <>
      {!(error || disabled) && (
        <div
          className={clsx(
            'h-full',
            'w-full',
            'px-4',
            'py-4',
            'rounded-md',
            'text-gray-600',
            'border'
          )}
        >
          <div className='flex justify-between'>
            <div className='flex items-center gap-2'>
              <OptionChip color={statusColor} label={status.toString()} />
              <span>|</span>
              <span className='opacity-70 text-xs'>{duration}ms</span>
            </div>
            <input type="checkbox" className='toggle' onClick={() => setTextWrap(!textWrap)} />
          </div>
          <div
            className={clsx(textWrap ? 'overflow-y-auto whitespace-pre-wrap' : 'truncate')}
            style={{ scrollbarWidth: 'thin' }}
          >
            {typeof body === 'string' ? body : JSON.stringify(body)}
          </div>
        </div>
      )}
    </>
  )
}
